export const DISHES_GET_REQUEST = 'DISHES_GET_REQUEST';
export const DISHES_GET_SUCCESS = 'DISHES_GET_SUCCESS';
export const DISHES_GET_FAILURE = 'DISHES_GET_FAILURE';

export const DISHES_GET_BY_ID_REQUEST = 'DISHES_GET_BY_ID_REQUEST';
export const DISHES_GET_BY_ID_SUCCESS = 'DISHES_GET_BY_ID_SUCCESS';
export const DISHES_GET_BY_ID_FAILURE = 'DISHES_GET_BY_ID_FAILURE';

export const DISHES_CREATE_OR_UPDATE_REQUEST = 'DISHES_CREATE_OR_UPDATE_REQUEST';
export const DISHES_CREATE_OR_UPDATE_SUCCESS = 'DISHES_CREATE_OR_UPDATE_SUCCESS';
export const DISHES_CREATE_OR_UPDATE_FAILURE = 'DISHES_CREATE_OR_UPDATE_FAILURE';

export const DISHES_DELETE_REQUEST = 'DISHES_DELETE_REQUEST';
export const DISHES_DELETE_SUCCESS = 'DISHES_DELETE_SUCCESS';
export const DISHES_DELETE_FAILURE = 'DISHES_DELETE_FAILURE';

export const RESET_DISHES_ERRORS = 'RESET_DISHES_ERRORS';

export const CHANGE_FORM_STEP = 'CHANGE_FORM_STEP';

export const RESET_DISHES_LIST_DATA = 'RESET_DISHES_LIST_DATA';

export const DISHES_CHANGE_POSITION_REQUEST = 'DISHES_CHANGE_POSITION_REQUEST';
export const DISHES_CHANGE_POSITION_SUCCESS = 'DISHES_CHANGE_POSITION_SUCCESS';